// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__0o9MC","popup":"Popup_popup__JSNpm","header":"Popup_header__3EieR","content":"Popup_content__gnkjR","closeButton":"Popup_closeButton__Z0fVR"};